import './CRUDLender.scss';
import Component from './CRUDLender.js';
export default Component;
